import React from "react";
import PropTypes from "prop-types";
import { FormGroup, Label } from "reactstrap";
import Select from "react-select";

const FilterSelect = ({
  id,
  label,
  onFilterChange,
  onClear,
  values,
  filterRenderer,
  selectedValue
}) => {
  const defaultOption = { value: "-1", label: "Seleccione una opción" };
  const options = [defaultOption];
  const selectValueAsOption = {
    value: selectedValue,
    label: filterRenderer(selectedValue)
  };
  values
    .filter(x => x)
    .map(value =>
      options.push({
        value,
        label: filterRenderer(value)
      })
    );
  return (
    <FormGroup>
      <Label for={id}>{label}</Label>
      <Select
        isClearable
        onChange={e => {
          if (e != null) {
            if (e.value === "0") {
              onFilterChange(0);
            } else {
              onFilterChange(e.value);
            }
          } else {
            onClear(id);
          }
        }}
        value={
          selectedValue || Number.isInteger(selectedValue) ? selectValueAsOption : defaultOption
        }
        options={options}
        isSearchable
      />
    </FormGroup>
  );
};
FilterSelect.propTypes = {
  selectedValue: PropTypes.string,
  onFilterChange: PropTypes.func,
  onClear: PropTypes.func,
  id: PropTypes.string,
  label: PropTypes.string,
  values: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  filterRenderer: PropTypes.func
};
FilterSelect.defaultProps = {
  onFilterChange: () => {},
  onClear: () => {},
  values: [],
  id: "",
  label: "",
  selectedValue: "",
  filterRenderer: value => value
};
export default FilterSelect;
